import { DreamDAO } from 'sparkello-core';
import { VuexDreamStore, WebDreamMapper } from '../index';
import { auth, firestore } from 'firebase/app';

import DocumentSnapshot = firestore.DocumentSnapshot;
import FieldValue = firestore.FieldValue;

export class DreamWebDAO extends DreamDAO<DocumentSnapshot, FieldValue, typeof auth, typeof firestore> {

  private static instance: DreamWebDAO;

  public static getInstance(): DreamWebDAO {
    if (!DreamWebDAO.instance) {
      DreamWebDAO.instance = new DreamWebDAO();
    }
    console.log(this.instance);
    return DreamWebDAO.instance;
  }

  public constructor() {
    super(new WebDreamMapper(), new VuexDreamStore(), auth, firestore);
    return this;
  }
}
